import { MsalAuthenticationResult, useMsal } from "@azure/msal-react";
import ReplayIcon from "@mui/icons-material/Replay";
import {
  Alert,
  Button,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { scopes } from "auth/utils/scopes";
import Logo from "common/assets/rpa-connect-logo.png";
import { useCallback } from "react";

const AuthenticationError = (props: MsalAuthenticationResult) => {
  console.error(props.error);
  const { instance } = useMsal();

  const handleClickRetryLogin = useCallback(async () => {
    try {
      await instance.loginPopup({
        scopes: scopes,
        prompt: "select_account",
      });
    } catch (error) {
      console.error(error);
    }
  }, [instance]);

  return (
    <Grid
      container
      sx={{
        height: 1,
        width: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 5,
      }}
    >
      <Grid item xs={12} md={8} lg={6}>
        <Paper variant="outlined" sx={{ p: 3 }}>
          <Stack spacing={2} alignItems="center">
            <img src={Logo} alt="rpa-connect-logo" width={180} />
            <Divider flexItem variant="middle" />
            <Typography
              variant="h2"
              color="grey.300"
              textAlign="center"
              fontWeight="bold"
            >
              Oops!
            </Typography>
            <Alert severity="error">
              <Stack spacing={1}>
                <Typography variant="body2" color="text.primary">
                  We encountered an unexpected error while attempting to sign
                  you in. If the issue persists, contact our support team for
                  further assistance.
                </Typography>
                <Button
                  variant="text"
                  color="inherit"
                  disableElevation
                  startIcon={<ReplayIcon />}
                  onClick={handleClickRetryLogin}
                >
                  Retry Login
                </Button>
              </Stack>
            </Alert>
          </Stack>
        </Paper>
      </Grid>
    </Grid>
  );
};
export default AuthenticationError;
